<template>
  <span class="ks-link">
    <a :href="url" v-bind="linkAttrs">
      <template v-if="useLabel">{{ label }}</template>
      <template v-else><slot /></template>
    </a>

    <template v-if="newTabButton">
      <a :href="url" target="_blank" v-tooltip.top="{ content: 'Open in New Tab', delay: { show: 1000 } }">
        <svgicon class="ks-icon-size-xs ks-link__new-tab-button" icon="ks-icon-new-tab" />
      </a>
    </template>
  </span>
</template>

<script>
  import { url } from 'Services/LinkService'
  import svgicon from 'vue-svgicon'
  import 'Components/icons'

  export default {
    name: 'ks-link',
    components: {
      svgicon,
    },
    computed: {
      linkAttrs () {
        const attrs = {}

        if (this.target) {
          attrs.target = this.target
        }

        return attrs
      },
      useLabel () {
        return this.label !== undefined
      },
      url: function () {
        return url({
          entityType: this.entityType,
          entityId: this.entityId,
          action: this.action,
        })
      },
    },
    props: {
      entityType: {
        type: String,
      },
      entityId: {
      },
      label: {
        type: String,
      },
      action: {
        type: String,
        default: '',
      },
      target: {
        type: String,
        default: null,
      },
      newTabButton: {
        type: Boolean,
        default: false,
      },
    },
  }

</script>
